import { createContext } from 'react';

export interface DreamComponentsContextType {
  responsiveImagesEnabled?: boolean;
  responsiveImagesBreakpoints?: number[];
  publicationTimeZone?: string;
}

export const DREAM_COMPONENTS_CONTEXT_DEFAULT_VALUES: DreamComponentsContextType = {
  responsiveImagesEnabled: false,
  responsiveImagesBreakpoints: [360, 430],
  publicationTimeZone: undefined,
};

export const DreamComponentsContext = createContext<DreamComponentsContextType | undefined>(undefined);
